import * as React from "react";
import { Table } from "../../../../newcomponents/table/table";
import { useTableKindId } from "../../../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../../../newcomponents/table/data/useTableItemQueryData";
import { TableHeaderRefreshButton } from "../../../../newcomponents/table/components/RefreshButton";
import { CustomTableCPLNQuery } from "../../../../newcomponents/table/components/TableCplnQuery";
import { NameDescriptionNoLinkColumn } from "../../../../newcomponents/table/columns/wellKnown/nameDescriptionNoLinkColumn";
import { TagsColumn } from "../../../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { linksOf } from "../../../../services/cpln";
import { Domain } from "../../../../schema/types/domain/entity";
import clsx from "clsx";

interface DomainTableItem extends Domain {
  selfLink: string;
}

interface Props {
  title: string;
  selections: string[];
  onSelectionsChange: (values: string[]) => void;
}
export const DomainTable: React.FC<Props> = ({ title, selections, onSelectionsChange }) => {
  const { kind, id } = useTableKindId("domain", "policy-create-target-list-domain");
  const qData = useTableItemQueryData<Domain>(kind, { fetchAllPages: true });

  const domainTableItems = qData.visibleItems.map((domain) => {
    const selfLink = linksOf(domain).self!;

    return {
      ...domain,
      selfLink: selfLink,
    };
  });

  return (
    <Table<DomainTableItem>
      title={title}
      data={domainTableItems}
      tableId={id}
      selectMode="multi"
      selectKey={"selfLink"}
      selections={selections}
      onSelectionsChange={onSelectionsChange}
      headerRenderer={() => {
        return (
          <>
            <TableHeaderRefreshButton onClick={qData.fetchItems} />
            <CustomTableCPLNQuery
              tableId={id}
              kind={kind}
              onQuery={qData.setQuery}
              isLoading={qData.isLoadingQueried}
            />
          </>
        );
      }}
      enableFilter
      isLoading={qData.isLoading}
      columns={[
        NameDescriptionNoLinkColumn(),
        {
          id: "domainStatusText",
          label: "Status",
          canGroupByDistinctValues: true,
          cell: ({ getValue }) => {
            const value = getValue();
            return (
              <span
                className={clsx("truncate pr-2", {
                  "color-action": value === "Ready",
                  "color-warning": value === "Warning",
                })}
              >
                {value}
              </span>
            );
          },
        },
        { id: "type", label: "Type", canGroupByDistinctValues: true },
        { id: "mappedGVC", label: "GVC" },
        { id: "endpointCount", label: "Endpoints" },
        TagsColumn(),
        CreatedColumn(),
        LastModifiedColumn(),
      ]}
    />
  );
};
